export enum PhysicalCapacity {    
    NoLimitations = 0,
    LimitedMobility = 5,
    WheelchairBoundOrWorse = 10
}